<template>
    <div id="app">
        <Header />
        <Nav />
        <MainContent />
    </div>
</template>

<script>
import Header from '@/layouts/Header/Header';
import Nav from '@/layouts/Nav/Nav';
import MainContent from '@/layouts/Content/Content';

export default {
    components: {
        Header,
        Nav,
        MainContent,
    },
};
</script>

<style lang="scss">
@import './Layout';
</style>
